import { styled, TableCell } from '@mui/material'

export const MainColumn = styled(TableCell)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        maxWidth: `100px`,
    },
}))
